var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.496 9.503 c -12.65 -12.65 -33.236 -12.65 -45.887 0 c 0 0 0 0 0 0 C 22.795 21.319 22.018 40.051 32.27 52.78 L 1.025 84.025 c -1.367 1.366 -1.367 3.583 0 4.949 C 1.708 89.658 2.604 90 3.5 90 s 1.792 -0.342 2.475 -1.025 L 37.219 57.73 c 5.914 4.764 13.123 7.149 20.333 7.149 c 8.309 0 16.618 -3.162 22.943 -9.488 C 93.147 42.739 93.147 22.155 80.496 9.503 z M 75.547 50.441 c -9.922 9.921 -26.066 9.921 -35.988 0 c -9.922 -9.922 -9.922 -26.066 0 -35.988 v 0 c 9.921 -9.922 26.066 -9.922 35.988 0 S 85.469 40.52 75.547 50.441 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#8f9bba",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.702 35.095 H 46.404 c -1.933 0 -3.5 -1.567 -3.5 -3.5 s 1.567 -3.5 3.5 -3.5 h 22.298 c 1.933 0 3.5 1.567 3.5 3.5 S 70.635 35.095 68.702 35.095 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#8f9bba",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.f4925dcc37314388c6e854abf575401d.svg";
export { ForwardRef as ReactComponent };